module.exports = __webpack_public_path__ + "static/img/6.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/6.jpg
// module id = jtnm
// module chunks = 36